var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[(_setup.isShowCreateGroup || _setup.isShowManageGroup || _setup.isShowSelectMember) && 'TUI-group']},[(_setup.isShowCreateGroup)?_c(_setup.CreateGroup):_vm._e(),(_setup.isShowManageGroup)?_c(_setup.ManageGroup):_vm._e(),(_setup.isShowSelectMember)?_c(_setup.SelectMember):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }